<template>
  <v-snackbar v-model="snackbar" :color="alert.type" :timeout="2500" bottom left>
    <span>
      <v-icon v-if="alert.type === 'success'" left class="white--text">mdi-check</v-icon>
      <v-icon v-if="alert.type === 'warning'" left class="white--text">mdi-alert-outline</v-icon>
      <v-icon v-if="alert.type === 'error'" left class="white--text">mdi-alert-circle-outline</v-icon>
      {{alert.message}}
    </span>
  </v-snackbar>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {

    data: () => ({
      snackbar: false
    }),

    computed: {
      ...mapGetters('alert', ['alert']),
    },

    methods: {
      ...mapActions('alert', ['clear'])
    },

    watch: {
      snackbar: {
        handler: function (snackbar) {
          if (snackbar === false)
            this.clear();
        },
        deep: true
      },
      alert: {
        handler: function (alert) {
          this.snackbar = (alert.visible === true);
        },
        deep: true
      }
    },

  }
</script>